import axios from 'axios';
import {mergeDeepRight} from 'ramda';

import {StaticConfig} from 'config/staticConfig';
import {AmicaApiRequest, ApiRequest} from 'shared/APIServices/types';
import {getApiUrl, getMockResponse, isEdgeAPI} from 'shared/APIServices/utils';
import {getAccessToken} from 'shared/utils/okta/okta-client';
import {getSessionUUID} from 'shared/utils/session';
import {getUserAgent} from 'utils/MobileBridge';

export const buildAmicaApiRequest = async <Data extends {}, Params extends {}, Headers extends {}>(
  amicaApiRequest: AmicaApiRequest<Data, Params, Headers>
): Promise<any> => {
  const mockResponse = await getMockResponse(amicaApiRequest);
  if (mockResponse && !window.sessionStorage.getItem('isCypressOnboardingCITest')) {
    return mockResponse;
  }
  const accessToken = await getAccessToken();
  const sessionUUID = getSessionUUID();

  const decoratedRequest: ApiRequest = mergeDeepRight(amicaApiRequest || {}, {
    url: getApiUrl() + amicaApiRequest.url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Amica-Agent': !StaticConfig.mobileApplicationLoader ? 'Amica-Web' : getUserAgent(),
      'accept-language': 'en_US',
      'x-gwre-session':
        (StaticConfig.edgeUUIDHeaderEnabled || StaticConfig.edgeUUIDHeaderAndCookieEnabled) &&
        isEdgeAPI(amicaApiRequest.url) &&
        sessionUUID
          ? sessionUUID
          : undefined,
      ...(amicaApiRequest.headers || {})
    },
    withCredentials: StaticConfig.edgeUUIDHeaderEnabled ? false : isEdgeAPI(amicaApiRequest.url),
    apiAction: amicaApiRequest.apiAction?.join('/')
  });
  return axios.request(decoratedRequest);
};
